// extracted by mini-css-extract-plugin
module.exports = {"categoryHeadline":"category_headline-module__categoryHeadline___1FrrV","advisor":"category_headline-module__advisor___1j03W"};